module.exports = __webpack_public_path__ + "static/media/Logo.ab4c2a25.svg";